import { Time } from "@angular/common";
import { LookupItemDTO } from "../../../shared/api-common-models";
import { EmailTemplateAttachmentDTO } from "src/app/settings/email-templates/models/editor-api-models";

export interface EmailTemplateDTO {
  emailTemplateId: number;
  name: string;
  /* priorityId: number;*/
  subject: string;
  body: string;
  sendEmailFromRecruiter: boolean;
  attachments: EmailTemplateAttachmentDTO[];
}

export enum EmailStatus {
  Sent = 1,
  Failed = 2,
  Pending = 3,
  Cancelled = 4
}

export enum MailPriority {
  Normal = 0,
  Low = 1,
  High = 2
}

export enum RequisitionStatus {
  Open = 1,
  Closed = 2,
  ClosedFilled = 3
}

export interface ShareEmailEditorDTO {
  subject: string;
  fromEmail: string;
  toEmail: string;
  body: string;
}

export interface EmailEditorDTO {
  emailId?: number | null;
  /** null if not assigned */
  emailTemplateId: number | null;
  fromEmail: string;
  toEmail: string;
  ccEmail: string,
  subject: string;
  body: string;
  priorityId: MailPriority | null;
  isScheduledForLater: boolean;
  scheduledDate?: Date;
  scheduledTime?: Time;
  attachments: EmailAttachmentDTO[];
}

export interface EmailAttachmentDTO {
  fileId: number;
  fileName: string;
  fileSize: number;
  filePath: string;
  downloadURL: string;
}

export const EmptyEmailEditorDTO: EmailEditorDTO = {
  emailId: null,
  body: "",
  emailTemplateId: null,
  fromEmail: "",
  priorityId: null,
  subject: "",
  toEmail: "",
  ccEmail: "",
  isScheduledForLater: false,
  scheduledDate: undefined,
  scheduledTime: undefined,
  attachments: []
};

export const EmptyShareEmailEditorDTO: ShareEmailEditorDTO = {
  subject: "",
  fromEmail: "",
  toEmail: "",
  body: ""
};

/** data needed to load the editor in new mode **/
export interface EmailEditorInitDTO {
  emailTemplates: EmailTemplateDTO[];
  sendingPeriods: LookupItemDTO<any>[];
  defaultAdminEmail: string;
  currentUserEmail: string;
}

